import script from "./WebDesign.vue?vue&type=script&setup=true&lang=js"
export * from "./WebDesign.vue?vue&type=script&setup=true&lang=js"

import "./WebDesign.vue?vue&type=style&index=0&id=5431e2e0&lang=sass&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5431e2e0"]])

export default __exports__